export default __webpack_public_path__ + "static/media/kogl_mark_eng.37b3db9c.svg";